/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { bindActionCreators } from 'redux';

import saveUseProduct from 'actions/product/saveUseProduct.action';
import basketIcon from 'assets/images/basket/Stock-order-icon.svg';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import CurrencySign from 'components/price/CurrencySign.component';
import ModalDeleteProduct from 'components/stock/ModalDeleteProduct.component';
import PUSHER from 'config/pusher.singleton';
import DELAY from 'constants/delay.const';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import delayed from 'utils/functions/delayed.util';
import currencySign from 'utils/intl/currencySign.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import isEmptyObject from 'utils/predicates/object/isEmptyObject.util';
import fixed from 'utils/values/fixed.util';

import ConfirmationDialog from 'clientProfile/components/common/ConfirmationDialog';
import PopupModalContainer from 'common/PopupModal';
import { getSalesReport, setDatePickerDate } from 'reports/actions';
import DateRangePicker from 'reports/Common/DateRangePicker';
import {
  addItemsToBasket,
  applyCostPriceChange,
  applyFilters,
  applyRetailPriceChange,
  bulkUpdate,
  clearFilter,
  deleteOrderItem,
  deleteProduct,
  editOrderItem,
  editStock,
  editStockMaxHolding,
  editStockMinHolding,
  emptyOrderBasket,
  generateOrderData,
  getLastOrderData,
  getSavedBasket,
  getStockCount,
  getStockData,
  loadBrands,
  loadCategories,
  loadSubBrands,
  PUSH_MSG_UPDATE_STOCK,
  revertCostorRetailPrice,
  saveBasket,
  sortData,
  tickSelectAll,
  toggleAllOrderItem,
  toggleFilter,
  toggleFilterValue,
  toggleOrderItem,
  toggleSelectItem,
  toogleCheckAll,
} from 'stocks/actions';
import EditManufacturerProductSidebar from 'stocks/components/common/EditManufacturerProductSidebar';
import FilterControl from 'stocks/components/common/Filter';
import InfoItem from 'stocks/components/common/InfoItem';
import ManageItemsSidebarContainer from 'stocks/components/common/ManageItemsSidebar';
import TableLastStockMovement from 'stocks/components/common/TableLastStockMovement';
import TableStocksManager from 'stocks/components/common/TableStocksManager';
import TableStocksOrdering from 'stocks/components/common/TableStocksOrdering';
import TableStocksUsedSold from 'stocks/components/common/TableStocksUsedSold';
import HeaderStocksFilter from 'stocks/components/HeaderStocksFilter';
import HeaderStocksInfoContainer from 'stocks/components/HeaderStocksInfoContainer';
import HeaderStocksNavigation from 'stocks/components/HeaderStocksNavigation';
import ModalConfirmation from 'stocks/components/Manager/ModalConfirmation.component';
import UseProductModal from 'stocks/components/Manager/UseProductModal.component';
import UseProductSearch from 'stocks/components/Manager/UseProductSearch.component';
import { ColumnsOrder, STOCK_MANAGER_PDF_TABLE_ID } from 'stocks/consts';
import { calculateCurrentLayout, mapStockOrders, mapStocks } from 'stocks/utils';

import { stockManagerPdfGenerator } from '../common/utils/stockManagerPdfGenerator';

import CN from './ManagerLayout.module.scss';

const L = logger('ManagerLayout');

class ManagerLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnOrder: calculateCurrentLayout(this.props.location.pathname),
      productToDelete: -1,
      filterByBrand: false,
      filterBySubBrand: false,
      filterByCategory: false,
      search: '',
      errorMessage: '',
      manageItems: false,
      isCategoryOpen: false,
      deleteModalSuccess: false,
      bulkDeleteModal: false,
      editedStock: null,
      clearBtn: false,
      lowInStock: false,
      modalUseProduct: false,
      valueProduct: '',
      valueQuantity: 1,
      inputQuantity: 'inputQuantity',
      inputName: 'inputName',
      productId: 0,
      productDropdown: false,
      error: false,
      modalSuccessful: false,
      modalErrorMessage: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getStockData(this.props.salonId);
    let fromDate = moment(this.props.lastDatesSelected.fromDate);
    if (fromDate.get('hour') !== 0) {
      fromDate = moment(this.props.lastDatesSelected.fromDate)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .utc()
        .toISOString();
    }

    PUSHER.redux.subscribe({
      channelName: `${this.props.salonId}_channel`,
      eventName: 'productQuantity',
      actionType: PUSH_MSG_UPDATE_STOCK,
    });

    this.props.loadBrands(this.props.salonId);
    this.props.loadSubBrands(this.props.salonId);
    this.props.loadCategories(this.props.salonId);
    this.props.getLastOrderData(this.props.salonId, false);
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      errorMessage: nextProps.errorMessage,
      columnOrder: calculateCurrentLayout(nextProps.location.pathname),
    });
    const { data } = nextProps;
    const noUsedSoldInRangeData =
      data.length > 0
        ? data.some((stock) => !fromAnyToBool(stock.usedSoldInRangeData) || isEmptyObject(stock.usedSoldInRangeData))
        : false;

    if (
      nextProps.lastDatesSelected.fromDate.toISOString() !== this.props.lastDatesSelected.fromDate.toISOString() ||
      nextProps.lastDatesSelected.toDate.toISOString() !== this.props.lastDatesSelected.toDate.toISOString() ||
      noUsedSoldInRangeData
    ) {
      this.props.getStockCount(
        this.props.salonId,
        nextProps.lastDatesSelected.fromDate,
        nextProps.lastDatesSelected.toDate,
      );
      this.props.getSavedBasket(this.props.salonId);
    }
  }

  componentWillUnmount() {
    this.props.saveBasket(this.props.salonId, this.props.orderItems);
    PUSHER.redux.unsubscribe({
      channelName: `${this.props.salonId}_channel`,
      eventName: 'productQuantity',
      actionType: PUSH_MSG_UPDATE_STOCK,
    });
  }

  onSearch = (v) => {
    this.setState({
      search: v
        // .trim()
        .normalize('NFD')
        .replace(/^0+/, '')
        .replace(/’/, '')
        .replace(/'/, '')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[\u00E9]/g, '')
        .toLowerCase(),
      clearBtn: true,
    });
  };
  clearSearch = () => {
    this.setState({ clearBtn: false, search: '' });
    this.props.toogleCheckAll(false);
  };

  onSelectProductName = (product) => {
    this.setState({
      valueProduct: product.title,
      productId: product.id,
      productDropdown: false,
    });
  };

  onBlurProduct = () =>
    delayed(DELAY.blur, () => {
      if (this.state.productDropdown) this.setState({ productDropdown: false, valueProduct: '' });
    });

  onSelectProductQuantity = (product) => {
    this.setState({
      valueQuantity: product.units_in_stock,
    });
  };

  onSearchProduct = (evt) => {
    const { inputName, inputQuantity } = this.state;
    const name = fromAnyToString(getAnyOrVoid('target.name', evt));
    const value = getAnyOrVoid('target.value', evt);

    if (name === inputName) {
      this.setState({
        valueProduct: fromAnyToString(value),
        productDropdown: true,
      });
    } else if (name === inputQuantity) {
      const min = 0;
      if (value < min) {
        this.setState({ error: true });
      } else {
        this.setState({
          valueQuantity: fromAnyToNumber(value),
          productDropdown: false,
          error: false,
        });
      }
    }
  };

  onClickSearchProduct = () => void this.setState({ valueProduct: '' });
  onClickSearchQuantity = () => void this.setState({ valueQuantity: '' });

  saveUseProduct = async () => {
    const { productId, valueQuantity: quantity } = this.state;
    const { salonId, getStockCount, lastDatesSelected, saveUseProduct } = this.props;

    try {
      this.setState({ modalUseProduct: false, modalErrorMessage: '' });

      const result = await saveUseProduct({ salonId, productId, quantity });
      // getStockCount needs to be called after saveUseProduct since we need to keep our state consistent.
      // When we update with saveUseProduct we update the data on the backend,
      // but PUSH_MSG_UPDATE_STOCK doesn't update usedSoldInRangeData.
      // To resolve that we call the second action after which updates that part of the stock item.
      // This was worked around in the PUSH_MSG_UPDATE_STOCK reducer by using 30 day data for the current usedSoldInRangeData,
      // which caused bugs when the range was different from 30 days in TableStocksUsedSold
      L.unignore(
        'saveUseProduct()',
        'getStockCount:',
        getStockCount(salonId, lastDatesSelected.fromDate, lastDatesSelected.toDate),
      );

      const { errorMessage } = asObject(result);
      const errorBody = getAnyOrVoid('error.body', result);

      if (errorMessage) {
        L.debug('saveUseProduct()', 'FAIL result:', result, errorMessage, errorBody);
        this.setState({ modalErrorMessage: errorMessage });
      } else {
        L.debug('saveUseProduct()', 'PASS result:', result);
        this.setState({ modalSuccessful: true, valueProduct: '', valueQuantity: 1 });
      }
    } catch (e) {
      L.warn('saveUseProduct()', 'FAIL error:', e);
      this.setState({
        modalErrorMessage: fromAnyToString(asObject(e).message) || this.props.t('stocks.managerLayout.defaultErrorMsg'),
      });
    } finally {
      delayed(DELAY.autohide2, () => this.setState({ modalSuccessful: false, modalErrorMessage: '' }));
    }
  };

  onSaveEdit = (data) => {
    this.props.editStock(this.props.salonId, data, true);
    this.closeEditSidebar();
  };

  onSaveBulkEdit = (brand, subBrand, category) =>
    new Promise((resolve) => {
      try {
        this.props.bulkUpdate(
          this.props.salonId,
          brand,
          subBrand,
          category,
          this.props.sorted.filter((c) => c.selected),
        );

        if (brand !== '' && this.props.brandList.filter((c) => c === brand).length === 0) {
          this.props.loadBrands(this.props.salonId);
        }
        if (subBrand !== '' && this.props.subBrandList.filter((c) => c === subBrand).length === 0) {
          this.props.loadSubBrands(this.props.salonId);
        }
        if (category !== '' && this.props.categoryList.filter((c) => c === category).length === 0) {
          this.props.loadCategories(this.props.salonId);
        }

        this.setState({ manageItems: false });

        resolve();
      } catch (error) {
        L.debug('onSaveBulkEdit()', 'Reject:', error);
      }
    });

  onSelectAllFilters = (field, setSelect) => {
    this.props.filters.forEach((filter) => {
      if (filter.field === field) {
        Object.keys(filter.values).map((key) => {
          this.props.toggleFilterValue(filter, key, setSelect);
          return true;
        });
      }
      return true;
    });
  };

  onSortFunction = (sortOption) => {
    this.props.sortData(sortOption);
  };

  onBulkDelete = () => {
    this.setState({ bulkDeleteModal: true });
  };
  onAllDelete = () => {
    const deleteSelectedItems = this.props.sorted.filter((c) => c.selected === true);
    deleteSelectedItems.forEach((item) => {
      this.props.deleteProduct(item.id);
      return true;
    });

    this.setState({ manageItems: false, deleteModalSuccess: true, bulkDeleteModal: false });
  };
  onChangeStocksDate = (startDate, endDate) => {
    this.props.setDatePickerDate(startDate, endDate);
    this.props.getStockCount(this.props.salonId, startDate, endDate);
  };
  onSelectItem = (editItem, isFromOrder) => {
    this.props.toggleSelectItem(editItem, !editItem.selected);
    if (!this.state.manageItems && !isFromOrder) {
      this.openManageItemsSidebar();
    }
  };
  onCheckAllItems = () => {
    if (this.state.search) {
      const searchResults = this.props.sorted.filter(this.searchFunc);

      const selected = !this.props.allItemsSelected;
      searchResults.forEach((item) => {
        this.props.toggleSelectItem(item, selected);
      });

      this.props.tickSelectAll(selected, false);
      if (!searchResults.some((c) => c.selected === true)) {
        this.setState({ manageItems: false });
      }
    } else {
      this.props.toogleCheckAll(!this.props.allItemsSelected);
    }

    if (!this.props.allItemsSelected) {
      this.openManageItemsSidebar();
    } else {
      this.setState({ manageItems: false });
    }
  };
  onSelectAllOrderItems = () => {
    const selected = !this.props.allOrderItemsSelected;
    if (this.state.search || this.state.lowInStock) {
      if (this.state.search) {
        const orderSearchResults = this.props.orderingData.filter(this.searchFunc);
        orderSearchResults.forEach((item) => {
          if (item.isInBasket === false) {
            this.props.toggleOrderItem(item, selected);
          }
        });
      }
      if (this.state.lowInStock) {
        const searchResults = this.props.orderingData.filter((c) =>
          c.units_in_stock || c.max_in_stock ? c.max_in_stock - c.units_in_stock > 0 : false,
        );

        searchResults.forEach((item) => {
          if (item.isInBasket === false) {
            this.props.toggleOrderItem(item, selected);
          }
        });
      }
      this.props.tickSelectAll(selected, true);
    } else {
      this.props.toggleAllOrderItem(!this.props.allOrderItemsSelected);
    }
  };
  deleteItem = () => {
    this.props.deleteProduct(this.state.productToDelete);
    this.setState({ productToDelete: -1 });
  };
  deleteItems = () => {
    this.setState({ bulkDeleteModal: false, deleteModalSuccess: true });
  };
  attemptDelete = (productId) => {
    this.props.deleteProduct(productId);
  };
  openEditProductSidebar = (stock) => {
    this.setState({
      filterByBrand: false,
      editedStock: stock,
      filterBySubBrand: false,
      filterByCategory: false,
      manageItems: false,
    });
  };
  openManageItemsSidebar = () => {
    this.setState({
      manageItems: true,
      filterByBrand: false,
      filterBySubBrand: false,
      filterByCategory: false,
      editedStock: null,
    });
  };
  closeEditSidebar = () => {
    this.setState({ editedStock: null });
  };
  closeManageSidebar = () => {
    this.props.toogleCheckAll(false);
    this.setState({ manageItems: false });
  };
  showFilterByBrand = () => {
    this.setState({
      editedStock: null,
      filterByBrand: !this.state.filterByBrand,
      filterBySubBrand: false,
      filterByCategory: false,
      isCategoryOpen: false,
    });
  };
  showFilterByCategory = () => {
    this.setState({
      editedStock: null,
      filterByBrand: false,
      filterByCategory: !this.state.filterByCategory,
      filterBySubBrand: false,
      isCategoryOpen: false,
    });
  };
  showFilterBySubBrand = () => {
    this.setState({
      editedStock: null,
      filterByBrand: false,
      filterBySubBrand: !this.state.filterBySubBrand,
      filterByCategory: false,
      isCategoryOpen: false,
    });
  };
  openDropdown = () => {
    this.setState({
      editedStock: null,
      filterByBrand: false,
      filterBySubBrand: false,
      filterByCategory: false,
      isCategoryOpen: !this.state.isCategoryOpen,
    });
  };
  closeFilter = () => {
    this.props.applyFilters();
    this.setState({ filterByBrand: false, filterBySubBrand: false, filterByCategory: false });
  };
  close = () => {
    this.setState({ deleteModalSuccess: false, manageItems: false });
  };
  cancelDeleteModal = () => {
    this.setState({ bulkDeleteModal: false });
  };
  hideError = () => {
    this.setState({ errorMessage: '' });
  };
  saveBasketOrder = () => {
    this.props.saveBasket(this.props.salonId, this.props.orderItems);
  };
  onCheckLowInStock = () => {
    this.setState({ lowInStock: !this.state.lowInStock });
  };
  onClearFilter = () => {
    this.setState({ lowInStock: false });
    this.props.clearFilter();
  };
  onGenerateOrderData = () => {
    this.props.generateOrderData(this.props.salonId, this.props.orderItems);
  };
  searchFunc = (el) =>
    el
      .getName()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString('en-GB')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[\u00E9]/g, '')
      .search(this.state.search) !== -1 ||
    el
      .getBrand()
      .trim()
      .normalize('NFD')
      .replace(/^0+'/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString('en-GB')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.state.search) !== -1 ||
    el
      .getFamily()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString('en-GB')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.state.search) !== -1 ||
    el
      .getCategory()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString('en-GB')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.state.search) !== -1 ||
    (el.barcode ? el.barcode.toString() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.state.search) !== -1;

  render() {
    const { t, currentCurrencySign } = this.props;
    const {
      valueProduct,
      valueQuantity,
      inputName,
      inputQuantity,
      productDropdown,
      error,
      modalUseProduct,
      modalSuccessful,
      modalErrorMessage,
      deleteModalSuccess,
      bulkDeleteModal,
    } = this.state;
    // HEADER calculations
    const gridData = this.props.sorted;
    const categoryKeys = this.props.sorted.filter(this.searchFunc);
    const productLines = this.props.data ? categoryKeys.length : 0;
    let totalCostValue = 0;
    let totalRetailValue = 0;
    let itemsUsed = 0;
    let costOfUsed = 0;
    let itemsSold = 0;
    let costOfSold = 0;
    let lastProductEdited = null;
    if (categoryKeys.length > 0) {
      categoryKeys.forEach((item) => {
        if (item.cost_price !== null && item.units_in_stock > 0) {
          totalCostValue += Number(item.cost_price) * item.units_in_stock;
        }
        if (item && item.usedSoldInRangeData) {
          const soldItems = fromAnyToBool(item.usedSoldInRangeData)
            ? parseFloat(getAnyOrNull('usedSoldInRangeData.sold', item))
            : 0;
          const usedItems = fromAnyToBool(item.usedSoldInRangeData)
            ? parseFloat(getAnyOrNull('usedSoldInRangeData.used', item))
            : 0;

          costOfUsed += Number(item.cost_price) * usedItems;
          costOfSold += Number(item.cost_price) * soldItems;
          itemsUsed += usedItems;
          itemsSold += soldItems;
        }
        if (item.units_in_stock > 0 && item.price > 0) {
          totalRetailValue += Number(item.price) * item.units_in_stock;
        }
        return true;
      });
      if (this.state.columnOrder === ColumnsOrder.LastStockMovement) {
        const lastStockHeader =
          this.props.data.length > 0
            ? this.props.data.sort((a, b) =>
                a.latest_change && b.latest_change
                  ? moment(b.latest_change.timestamp).diff(moment(a.latest_change.timestamp))
                  : 0,
              )
            : [];
        lastProductEdited = lastStockHeader[0];
      }
    }
    const brandFilterSelected = this.props.filters.filter((d) => d.field === 'brand');
    let filterBrandCount = 0;
    let allBrandSelected = true;
    if (brandFilterSelected[0]) {
      const count = brandFilterSelected[0].values;
      Object.keys(count).map((k) => {
        if (count[k] === true) {
          filterBrandCount++;
        } else {
          allBrandSelected = false;
        }
        return true;
      });
    }
    const subbrandFilterSelected = this.props.filters.filter((d) => d.field === 'sub_brand');
    let filterSubBrandCount = 0;
    let allSubBrandSelected = true;
    if (subbrandFilterSelected[0]) {
      const countSub = subbrandFilterSelected[0].values;
      Object.keys(countSub).map((k) => {
        if (countSub[k] === true) {
          filterSubBrandCount++;
        } else {
          allSubBrandSelected = false;
        }
        return true;
      });
    }
    const categoryFilterSelected = this.props.filters.filter((d) => d.field === 'category_name');
    let filterCategoryCount = 0;
    let allCategorySelected = true;
    if (categoryFilterSelected[0]) {
      const countCat = categoryFilterSelected[0].values;
      Object.keys(countCat).map((k) => {
        if (countCat[k] === true) {
          filterCategoryCount++;
        } else {
          allCategorySelected = false;
        }
        return true;
      });
    }
    const finalOrderingData = mapStocks(this.props.orderingData);
    const orderingSelection = this.props.orderingData.filter(
      (c) => c.selected === true && c.isInBasket === false,
    ).length;
    const groupOrderItems = mapStockOrders(this.props.orderItems);
    let totalOrderCost = 0;
    this.props.orderItems.forEach((item) => {
      totalOrderCost += item.cost_price ? item.cost_price * item.quantity : 0;
    });
    let countLowInStock = 0;
    const countLow = gridData.filter((c) =>
      c.units_in_stock || c.max_in_stock ? c.max_in_stock - c.units_in_stock > 0 : false,
    );
    if (countLow.length > 0) {
      countLowInStock = countLow.length;
    }

    const listOfQuantity = this.props.data;
    const uniques = Object.values(
      listOfQuantity.reduce((a, c) => {
        // eslint-disable-next-line no-param-reassign
        a[c.units_in_stock] = c;
        return a;
      }, {}),
    );
    const renderProducts = this.props.data
      .filter((product) => valueProduct === '' || product.title.toLowerCase().includes(valueProduct.toLowerCase()))
      .map((product) => (
        <li
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
          role="button"
          tabIndex={0}
          onClick={() => {
            this.onSelectProductName(product);
          }}
          key={product.id}
        >
          {product.title}
        </li>
      ));
    const renderProductsByQuantity = uniques
      .filter((product) => valueQuantity === '' || String(product.units_in_stock).includes(valueQuantity))
      .map((product) => (
        <li
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
          role="button"
          tabIndex={0}
          onClick={() => {
            this.onSelectProductQuantity(product);
          }}
          key={product.id}
        >
          {Number(product.units_in_stock).toFixed(2)}
        </li>
      ));

    const generateStockManagerPdfTable = () =>
      stockManagerPdfGenerator({
        // TODO: date localisation
        date: moment().format('Do MMMM YYYY'),
        totalCost: currencySign({ value: totalCostValue, currentSalonAbbr: currentCurrencySign }),
        totalRetail: currencySign({ value: totalRetailValue, currentSalonAbbr: currentCurrencySign }),
        salonId: this.props.salonId,
        t,
      });

    return (
      <div>
        {this.state.errorMessage && (
          <PopupModalContainer
            popupTitle={t('common.error')}
            popupMessage={this.state.errorMessage}
            buttonText={t('common.buttons.okay')}
            buttonCallback={this.hideError}
          />
        )}
        {this.state.productToDelete !== -1 && (
          <ConfirmationDialog
            title={t('stocks.managerLayout.deleteItemModal.title')}
            leftButtonText={t('common.buttons.no')}
            onLeft={() => this.setState({ productToDelete: -1 })}
            rightButtonText={t('common.buttons.yes')}
            onRight={this.deleteItem}
            onCancel={() => this.setState({ productToDelete: -1 })}
          >
            <p>{t('stocks.managerLayout.deleteItemModal.description')}</p>
          </ConfirmationDialog>
        )}
        <HeaderStocksNavigation salonId={this.props.salonId} history={this.props.history} />
        {this.state.columnOrder === ColumnsOrder.ManagerLayoutColumnsOrder && (
          <HeaderStocksInfoContainer>
            <div className="scroll has-pdf-btn">
              <div className="scroll-content">
                <div className="flex-info-container">
                  <InfoItem
                    text={t('stocks.managerLayout.managerHeaderInfoItems.item1')}
                    value={productLines}
                    tooltip
                    tooltipText={t('stocks.managerLayout.managerHeaderInfoItems.item1Tooltip')}
                  />
                  <InfoItem
                    text={t('stocks.managerLayout.managerHeaderInfoItems.item2')}
                    value={
                      <>
                        <CurrencySign value={totalCostValue} />
                      </>
                    }
                    tooltip
                    tooltipText={t('stocks.managerLayout.managerHeaderInfoItems.item2Tooltip')}
                  />
                  <InfoItem
                    text={t('stocks.managerLayout.managerHeaderInfoItems.item3')}
                    value={
                      <>
                        <CurrencySign value={totalRetailValue} />
                      </>
                    }
                    tooltip
                    tooltipText={t('stocks.managerLayout.managerHeaderInfoItems.item3Tooltip')}
                  />
                  <InfoItem
                    text={t('stocks.managerLayout.managerHeaderInfoItems.item4')}
                    value={countLowInStock}
                    tooltip
                    tooltipText={t('stocks.managerLayout.managerHeaderInfoItems.item4Tooltip')}
                  />
                  <InfoItem
                    text={t('stocks.managerLayout.managerHeaderInfoItems.item5')}
                    // TODO: date localisation
                    value={this.props.lastOrderDate ? `${moment(this.props.lastOrderDate).format('Do MMM YYYY')}` : '-'}
                  />
                </div>
              </div>
            </div>
          </HeaderStocksInfoContainer>
        )}
        {this.state.columnOrder === ColumnsOrder.UsedSoldOverDateRange && (
          <HeaderStocksInfoContainer>
            <div className="dpicker-container">
              <DateRangePicker
                tag="ManagerLayout__range-picker"
                lastDatesSelected={this.props.lastDatesSelected}
                onChangeDate={this.onChangeStocksDate}
                location={this.props.location}
                isFetching={false}
              />
            </div>
            <div className="scroll">
              <div className="scroll-content">
                <div className="flex-info-container align-center no-padding">
                  <InfoItem
                    text={t('stocks.managerLayout.usedSoldHeaderInfoItems.item1')}
                    value={itemsUsed.toFixed(2)}
                  />
                  <InfoItem
                    text={t('stocks.managerLayout.usedSoldHeaderInfoItems.item2')}
                    value={
                      <>
                        <CurrencySign value={costOfUsed} />
                      </>
                    }
                  />
                  <InfoItem text={t('stocks.managerLayout.usedSoldHeaderInfoItems.item3')} value={itemsSold} />
                  <InfoItem
                    text={t('stocks.managerLayout.usedSoldHeaderInfoItems.item4')}
                    value={
                      <>
                        <CurrencySign value={costOfSold} />
                      </>
                    }
                  />
                </div>
              </div>
            </div>
          </HeaderStocksInfoContainer>
        )}
        {this.state.columnOrder === ColumnsOrder.LastStockMovement && (
          <HeaderStocksInfoContainer>
            <div className="scroll">
              <div className="scroll-content">
                <div className="flex-info-container align-center">
                  <InfoItem
                    text={t('stocks.managerLayout.lastMovementHeaderInfoItems.item1')}
                    value={lastProductEdited ? lastProductEdited.title : '0'}
                  />
                  <InfoItem
                    text={t('stocks.managerLayout.lastMovementHeaderInfoItems.item2')}
                    value={
                      lastProductEdited && lastProductEdited.latest_change
                        ? moment(lastProductEdited.latest_change.timestamp).format('DD-MM-YYYY') // TODO: date localisation
                        : ''
                    }
                  />
                  <InfoItem
                    text={t('stocks.managerLayout.lastMovementHeaderInfoItems.item3')}
                    value={
                      lastProductEdited && lastProductEdited.latest_change ? lastProductEdited.latest_change.amount : ''
                    }
                  />
                  <InfoItem
                    text={t('stocks.managerLayout.lastMovementHeaderInfoItems.item4')}
                    value={
                      lastProductEdited && lastProductEdited.latest_change && lastProductEdited.latest_change.type
                        ? lastProductEdited.latest_change.type.charAt(0).toUpperCase() +
                          lastProductEdited.latest_change.type.slice(1).replace('_', ' ')
                        : ''
                    }
                  />
                </div>
              </div>
            </div>
          </HeaderStocksInfoContainer>
        )}
        {this.state.columnOrder === ColumnsOrder.StockHoldingColumnsOrder && (
          <HeaderStocksInfoContainer>
            <div className="scroll">
              <div className="scroll-content">
                <div className="flex-info-container align-center">
                  <div className="stock-ordering">
                    <img src={basketIcon} alt="Basket icon" />
                  </div>
                  <div className="selected-products">
                    <div>
                      {orderingSelection}
                      {S.space}
                      {orderingSelection >= 2
                        ? t('stocks.managerLayout.orderingHeaderInfoItems.selectedProducts')
                        : t('stocks.managerLayout.orderingHeaderInfoItems.selectedProduct')}
                    </div>
                    {orderingSelection > 0 && (
                      <button id="add-to-basket" className="btn btn-violet" onClick={this.props.addItemsToBasket}>
                        {t('stocks.managerLayout.orderingHeaderInfoItems.addButton')}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </HeaderStocksInfoContainer>
        )}
        <div
          className={
            this.state.filterByBrand
              ? 'is-brand-open'
              : null || this.state.filterBySubBrand
                ? 'is-sub-open'
                : null || this.state.filterByCategory
                  ? 'is-cat-open'
                  : null
          }
        >
          {this.props.filters.length > 0 && (
            <div
              className={this.state.columnOrder === ColumnsOrder.StockHoldingColumnsOrder ? 'toolbar short' : 'toolbar'}
            >
              <HeaderStocksFilter
                cssPosition={this.state.columnOrder === ColumnsOrder.ManagerLayoutColumnsOrder ? 'has-pdf-btn' : 'asd'}
                hasAnyProducts={this.props.hasAnyProducts}
                isCategoryOpen={this.state.isCategoryOpen}
                showLowProducts={this.state.columnOrder === ColumnsOrder.StockHoldingColumnsOrder}
                selectedBrandCount={allBrandSelected || filterBrandCount === 0 ? null : filterBrandCount}
                selectedSubBrandCount={allSubBrandSelected || filterSubBrandCount === 0 ? null : filterSubBrandCount}
                selectedCategoryCount={allCategorySelected || filterCategoryCount === 0 ? null : filterCategoryCount}
                clearBtn={this.state.clearBtn}
                clearFilter={this.onClearFilter}
                openDropdown={this.openDropdown}
                onSearch={this.onSearch}
                showFilterByBrand={this.showFilterByBrand}
                showFilterBySubBrand={this.showFilterBySubBrand}
                showFilterByCategory={this.showFilterByCategory}
                clearSearch={this.clearSearch}
                useProductModal={() => this.setState({ modalUseProduct: true })}
                jsPdfGenerator={generateStockManagerPdfTable}
                search={this.state.search}
                lowInStock={this.state.lowInStock}
                onCheckLowInStock={this.onCheckLowInStock}
                salonId={this.props.salonId}
                additionalClass={
                  this.state.columnOrder === ColumnsOrder.StockHoldingColumnsOrder ? 'stock-order-filter' : ' '
                }
              >
                {this.state.filterByBrand && (
                  <div className={this.state.filterByBrand ? 'filterByBrand' : 'hidden'}>
                    <div className="filter-sidebar animated fadeIn">
                      <FilterControl
                        field="brand"
                        isAllSelected={allBrandSelected}
                        filters={this.props.filters}
                        onCloseFilter={this.closeFilter}
                        toggleFilter={this.props.toggleFilter}
                        onSelectAllFilterValue={this.onSelectAllFilters}
                      />
                    </div>
                  </div>
                )}
                {this.state.filterBySubBrand && (
                  <div className={this.state.filterBySubBrand ? 'filterBySubBrand' : 'hidden'}>
                    <div className="filter-sidebar animated fadeIn">
                      <FilterControl
                        field="sub_brand"
                        isAllSelected={allSubBrandSelected}
                        filters={this.props.filters}
                        onCloseFilter={this.closeFilter}
                        toggleFilter={this.props.toggleFilter}
                        onSelectAllFilterValue={this.onSelectAllFilters}
                      />
                    </div>
                  </div>
                )}
                {this.state.filterByCategory && (
                  <div className={this.state.filterByCategory ? 'filterByCategory' : 'hidden'}>
                    <div className="filter-sidebar animated fadeIn">
                      <FilterControl
                        sorted={this.props.sorted}
                        field="category_name"
                        isAllSelected={allCategorySelected}
                        filters={this.props.filters}
                        onCloseFilter={this.closeFilter}
                        toggleFilter={this.props.toggleFilter}
                        onSelectAllFilterValue={this.onSelectAllFilters}
                      />
                    </div>
                  </div>
                )}
              </HeaderStocksFilter>
            </div>
          )}
        </div>
        <div
          className={
            this.state.editedStock ||
            this.state.filterByBrand ||
            this.state.filterBySubBrand ||
            this.state.filterByCategory
              ? 'stocks-layout sticky-container-stocks'
              : 'stocks-layout sticky-container-stocks'
          }
        >
          {this.state.columnOrder === ColumnsOrder.ManagerLayoutColumnsOrder && (
            <TableStocksManager
              isFetching={this.props.isFetching}
              salonId={this.props.salonId}
              allItemsSelected={this.props.allItemsSelected}
              sorted={this.props.sorted}
              editStock={this.props.editStock}
              editStockMinHolding={this.props.editStockMinHolding}
              editStockMaxHolding={this.props.editStockMaxHolding}
              onAddSort={this.onSortFunction}
              OnClickRow={this.openEditProductSidebar}
              onClickCheckbox={this.openManageItemsSidebar}
              search={this.state.search}
              columnOrder={this.state.columnOrder}
              toogleCheckAll={this.onCheckAllItems}
              toggleSelectItem={this.onSelectItem}
            />
          )}
          {this.state.columnOrder === ColumnsOrder.UsedSoldOverDateRange && (
            <TableStocksUsedSold
              data={gridData}
              onAddSort={this.onSortFunction}
              OnClickRow={this.openEditProductSidebar}
              search={this.state.search}
            />
          )}
          {this.state.columnOrder === ColumnsOrder.LastStockMovement && (
            <TableLastStockMovement
              data={gridData}
              onAddSort={this.onSortFunction}
              OnClickRow={this.openEditProductSidebar}
              search={this.state.search}
            />
          )}
          {this.state.columnOrder === ColumnsOrder.StockHoldingColumnsOrder && (
            <TableStocksOrdering
              isChecked={false}
              emptyBasket={this.props.orderItems.length > 0}
              allItemsSelected={this.props.allOrderItemsSelected}
              basketSaved={this.props.basketSaved}
              data={finalOrderingData}
              csvData={this.props.orderItems.map((e) => ({
                ...e,
                barcode: e.barcode ?? '-',
                quantity: e.quantity,
              }))}
              lowInStock={this.state.lowInStock}
              orderItems={groupOrderItems}
              orderItemsCount={this.props.orderItems.length}
              totalOrderItemsCost={totalOrderCost}
              search={this.state.search}
              salonId={this.props.salonId}
              geratedOrderNumber={this.props.geratedOrderNumber}
              onAddSort={this.onSortFunction}
              saveBasket={this.saveBasketOrder}
              deleteOrderItem={this.props.deleteOrderItem}
              generateOrderData={this.onGenerateOrderData}
              getLastOrderData={this.props.getLastOrderData}
              editOrderItem={this.props.editOrderItem}
              emptyOrderBasket={this.props.emptyOrderBasket}
              toggleOrderItem={this.props.toggleOrderItem}
              toogleCheckAll={this.onSelectAllOrderItems}
            />
          )}
        </div>
        <aside className={this.state.editedStock ? 'product-sidebar animated slideInRight' : 'product-sidebar hidden'}>
          {this.state.editedStock && (
            <EditManufacturerProductSidebar
              brandList={this.props.brandList}
              subBrandList={this.props.subBrandList}
              categoryList={this.props.categoryList}
              data={gridData}
              selectedData={this.state.editedStock}
              isSaving={this.props.isSavingStock}
              filters={this.props.filters}
              permission=""
              attemptDelete={this.attemptDelete}
              onClose={this.closeEditSidebar}
              onSave={this.onSaveEdit}
            />
          )}
        </aside>
        <aside className={this.state.manageItems ? 'product-sidebar animated slideInRight' : 'product-sidebar hidden'}>
          {this.state.manageItems && (
            <ManageItemsSidebarContainer
              brandList={this.props.brandList}
              subBrandList={this.props.subBrandList}
              categoryList={this.props.categoryList}
              data={gridData}
              onClose={this.closeManageSidebar}
              onDelete={this.onBulkDelete}
              onUpdateItems={this.onSaveBulkEdit}
              applyCostPriceChange={this.props.applyCostPriceChange}
              applyRetailPriceChange={this.props.applyRetailPriceChange}
              revertCostorRetailPrice={this.props.revertCostorRetailPrice}
            />
          )}
        </aside>
        {modalUseProduct && (
          <UseProductModal
            title={t('stocks.managerLayout.useProductModal.title')}
            onSave={this.saveUseProduct}
            onCancel={() => void this.setState({ modalUseProduct: false, valueProduct: '', valueQuantity: 1 })}
            disabled={!valueProduct || !valueQuantity}
          >
            <UseProductSearch
              items={renderProducts}
              dropdown={productDropdown}
              name={inputName}
              value={valueProduct}
              type="text"
              onChange={this.onSearchProduct}
              onClick={this.onClickSearchProduct}
              onBlur={this.onBlurProduct}
              placeholder={t('stocks.managerLayout.useProductModal.productNamePlaceholder')}
              label={t('stocks.managerLayout.useProductModal.productNameLabel')}
              autoFocus
            />
            <UseProductSearch
              items={renderProductsByQuantity}
              name={inputQuantity}
              value={valueQuantity}
              type="number"
              onChange={this.onSearchProduct}
              onClick={this.onClickSearchQuantity}
              label={t('stocks.managerLayout.useProductModal.quantityUsedLabel')}
              error={error && t('stocks.managerLayout.useProductModal.quantityUsedValidationErr')}
              inputMode="decimal"
            />
          </UseProductModal>
        )}

        {fromAnyToBool(modalSuccessful) && (
          <ModalConfirmation title={t('stocks.managerLayout.confirmationModalTitle')} displayImage />
        )}
        {fromAnyToBool(modalErrorMessage) && <ModalConfirmation title={modalErrorMessage} />}

        <div
          className={this.state.editedStock ? 'close-overlay' : 'hidden'}
          onClick={this.closeEditSidebar}
          role="button"
          tabIndex="0"
        />

        {fromAnyToBool(bulkDeleteModal) && (
          <ModalDeleteProduct
            icon="alert"
            title={t('stocks.managerLayout.deleteProductModal.title2')}
            message={t('stocks.managerLayout.deleteProductModal.description2')}
            onClose={this.cancelDeleteModal}
            onConfirm={this.onAllDelete}
          />
        )}
        {fromAnyToBool(deleteModalSuccess) && (
          <SalonModal tag="ManagerLayout__modal--success" isOpen variant="noFooter">
            <SalonModal.Header>
              <div className={CN.closeButtonContainer}>
                <Button variant="empty" onClick={this.close}>
                  <Icon variant="close" variantInvert />
                </Button>
              </div>
            </SalonModal.Header>
            <SalonModal.Body>
              <IconStatus variant="success">
                <Icon variant="confirm" width="lg" />
              </IconStatus>
              <div className={CN.contentModal}>
                <div className={CN.titleModal}>{t('stocks.managerLayout.productDeleted')}</div>
              </div>
            </SalonModal.Body>
          </SalonModal>
        )}

        {/* Hacky workaround to make the pdf downloadable from each tab of manager layout */}
        {/* PDF start */}
        {/* The id={STOCK_MANAGER_PDF_TABLE_ID} is used to generate the downloadable PDF file */}
        <table id={STOCK_MANAGER_PDF_TABLE_ID} style={{ display: 'none' }}>
          <thead>
            <tr>
              <th>{t('stocks.tableHeaders.brand')}</th>
              <th>{t('stocks.tableHeaders.subBrand')}</th>
              <th>{t('stocks.tableHeaders.productName')}</th>
              <th>{t('stocks.tableHeaders.costPrice')}</th>
              <th>{t('stocks.tableHeaders.retailPrice')}</th>
              <th>{t('stocks.tableHeaders.stockQuantity')}</th>
              <th>{t('stocks.tableHeaders.usedLast30d')}</th>
              <th>{t('stocks.tableHeaders.minHolding')}</th>
              <th>{t('stocks.tableHeaders.maxHolding')}</th>
            </tr>
          </thead>
          <tbody>
            {categoryKeys.length > 0 &&
              categoryKeys.map((catKey) => {
                const stocks = catKey;
                return (
                  <tr key={stocks.id}>
                    <td>{stocks.brand ? stocks.brand : t('common.unknown')}</td>
                    <td>{stocks.sub_brand}</td>
                    <td>{stocks.title}</td>
                    <td>
                      {stocks.cost_price && <CurrencySign />}
                      {stocks.cost_price ? stocks.cost_price : S.minus}
                    </td>
                    <td>
                      {stocks.price && <CurrencySign />}
                      {stocks.price ? parseFloat(stocks.price).toFixed(2) : S.minus}
                    </td>
                    <td>{fixed(stocks.units_in_stock)}</td>
                    <td>{stocks.sold_last_30_days + stocks.used_last_30_days}</td>
                    <td>{stocks.min_in_stock ? stocks.min_in_stock : S.minus}</td>
                    <td>{stocks.max_in_stock ? stocks.max_in_stock : S.minus}</td>
                  </tr>
                );
              })}
            {categoryKeys.length === 0 && (
              <tr>
                <td style={{ textAlign: 'center' }}>{t('stocks.tableHeaders.noProductsMsg')}</td>
              </tr>
            )}
          </tbody>
        </table>
        {/* PDF end */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isFetching: state.stockManagement.stock.isFetching,
  salonId: state.currentSalon.id,
  lastDatesSelected: state.reports.lastDatesSelected,
  errorMessage: state.stockManagement.stock.errorMessage,
  data: state.stockManagement.stock.filtered,
  sorted: state.stockManagement.stock.sorted,
  filters: state.stockManagement.stock.filters,
  orderingData: state.stockManagement.stock.orderingData,
  sortOrder: state.stockManagement.stock.sortOrder,
  isSavingStock: state.stockManagement.stock.isPosting,
  hasAnyProducts: !!state.stockManagement.stock.apiData.length,
  allItemsSelected: state.stockManagement.stock.allItemsSelected,
  brandList: state.stockManagement.stock.brandList,
  subBrandList: state.stockManagement.stock.subBrandList,
  categoryList: state.stockManagement.stock.categoryList,
  orderItems: state.stockManagement.stock.orderItems,
  basketSaved: state.stockManagement.stock.basketSaved,
  lastOrderDate: state.stockManagement.stock.lastOrderDate,
  geratedOrderNumber: state.stockManagement.stock.geratedOrderNumber,
  allOrderItemsSelected: state.stockManagement.stock.allOrderItemsSelected,
  currentCurrencySign: selectCurrentSalonCurrency(state),
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setDatePickerDate,
      getSalesReport,
      getStockData,
      loadBrands,
      loadSubBrands,
      getStockCount,
      editStock,
      editStockMinHolding,
      editStockMaxHolding,
      deleteProduct,
      deleteOrderItem,
      editOrderItem,
      applyFilters,
      addItemsToBasket,
      toggleFilter,
      toggleFilterValue,
      sortData,
      clearFilter,
      emptyOrderBasket,
      toogleCheckAll,
      toggleAllOrderItem,
      toggleSelectItem,
      toggleOrderItem,
      tickSelectAll,
      bulkUpdate,
      saveBasket,
      generateOrderData,
      getLastOrderData,
      getSavedBasket,
      applyCostPriceChange,
      applyRetailPriceChange,
      revertCostorRetailPrice,
      loadCategories,
      saveUseProduct,
    },
    dispatch,
  );

const ManagerLayoutHoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ManagerLayout)));

export default ManagerLayoutHoc;
